// Single source of truth for launch scope. These tool route slugs exist in the
// codebase but are hidden from the UI and blocked from direct navigation until
// marketing drops them post-launch. To re-enable a tool, remove its slug below.
export const HIDDEN_TOOL_PATHS = [
  'game-night',
  'newspaper',
  'championship-odds',
  'bench-regret',
  'fantasy-dna',
  'grudge-match',
  'power-rankings',
  'trash-talk',
  'crystal-ball',
  'team-news',
  'league-news',
]
